import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import ForgotPass from './components/ForgotPass';
import UpdatePassword from './components/UpdatePassword';
import { Navigate } from 'react-router-dom';

function App() {
  const ProtectedRoute = ({ children }) => {
      const token = localStorage.getItem('access_token');
  
      if (token === null || token === 'undefined') {
          return <Navigate to="/login" />;
      }
  
      return children;
  };

  return (
    <>
    <BrowserRouter>
    <Routes>
    <Route path="/" element={<ProtectedRoute><Dashboard/></ProtectedRoute>} />
    <Route path="/login" element={<LoginPage/>} />
    <Route path="/forgot-password" element={<ForgotPass/>} />
    <Route path="/reset-password/:token" element={<UpdatePassword/>} />
    </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
